import React from 'react'
import { useContext, useState } from 'react'
import AppContext from '../context/appContext'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useRef } from 'react'

const Dashboard = () => {
    const context = useContext(AppContext)
    const { adminToken, setAdminToken, siteData, setSiteData, editSiteInfo, editLoader} = context
    const history = useHistory()
    if (!adminToken) {
        history.push("/admin")
    }
    // const [currentState, setCurrentState] = useState("Basic")


    

    return (
        <div>
            <nav class="navbar navbar-expand-lg bg-body-tertiary shadow" >
                <div class="container-fluid">
                    <a class="navbar-brand" href="#">Admin Panel</a>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav me-auto mb-2 mb-lg-0">

                        </ul>
                        <form class="d-flex" role="search">
                            <button onClick={() => { setAdminToken(null) }} className="btn btn-outline-danger">Logout</button>

                        </form>
                    </div>
                </div>
            </nav>
            <div className='container my-5'>

                {/* <h1 className="text-center">Admin Panel</h1> */}

                

                {siteData&&<div className='my-3'>
                    {/* <h4>Site Tite</h4>
                    <input value={siteData.title} onChange={(e) => setSiteData({ ...siteData, title: e.target.value })} type="text" placeholder='Site Name' className="form-control my-2 " />
                    <h4>Site Email</h4>
                    <input value={siteData.email} onChange={(e) => setSiteData({ ...siteData, email: e.target.value })} type="text" placeholder='Site Email' className="form-control my-2 " /> */}
                    <h4>Site Whatsapp Number</h4>
                    <input value={siteData.phone} onChange={(e) => setSiteData({ ...siteData, phone: e.target.value })} type="text" placeholder='Site Whatsapp Number' className="form-control my-2 " />
                    <h4>Site Phone Number </h4>
                    <input value={siteData.description} onChange={(e) => setSiteData({ ...siteData, description: e.target.value })} type="text" placeholder='Site Phone Number' className="form-control my-2 " />
                   
                    {/* <h4 className='my-2'>Site About Description</h4>
                    <textarea value={siteData.about} onChange={(e) => setSiteData({ ...siteData, about: e.target.value })} class="form-control" id="exampleFormControlTextarea1 my-2" rows="4"></textarea> */}
                    <div className="d-flex">
                        <button disabled={editLoader} onClick={() => { editSiteInfo() }} className="btn btn-outline-primary my-2">Save Changes</button>
                        {editLoader && <div className="p-2">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>}

                    </div>
                </div>}
                
                
            </div>
            

        </div >
    )
}

export default Dashboard